import AgencyCandidateApiAgency from '@/api/AgencyCandidateApiAgency';
import BaseService from '@/services/BaseService';

class AgencyCandidateService extends BaseService {
	async addAsync (...args: Parameters<typeof AgencyCandidateApiAgency.add>) {
		const { data } = await AgencyCandidateApiAgency.add(...args);
		return data;
	}

	async addMutipleAsync (...args: Parameters<typeof AgencyCandidateApiAgency.addMutiple>) {
		const { data } = await AgencyCandidateApiAgency.addMutiple(...args);
		return data;
	}

	async gridAsync (...args: Parameters<typeof AgencyCandidateApiAgency.grid>) {
		const { data } = await AgencyCandidateApiAgency.grid(...args);
		return data;
	}

	async getDetailsAsync (...args: Parameters<typeof AgencyCandidateApiAgency.getDetails>) {
		const { data } = await AgencyCandidateApiAgency.getDetails(...args);
		return data;
	}

	async deleteAsync (...args: Parameters<typeof AgencyCandidateApiAgency.delete>) {
		const { data } = await AgencyCandidateApiAgency.delete(...args);
		return data;
	}
}

const agencyCandidateServiceSingleton = new AgencyCandidateService();

export default function useAgencyCandidateService () {
	return agencyCandidateServiceSingleton;
}
